import React from 'react';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

import Putaleng from './image/booking/putaleng.png';
// Dữ liệu lịch trình chuyến đi Tà Chì Nhù
const Schedule = [
  {
    day: "Chiều Thứ 5",
    activities: [
      { time: "06:30 PM", description: "Khởi hành từ Hà Nội, hướng về bản văn hóa Sì Thâu Chải - Lai Châu" },
      { time: "11:30 PM", description: "Có mặt và nhận phòng tại homestay của người Dao tại Sì Thâu Chải" },
      { 
        description: "Hãy dành thời gian hít hà không khí trong lành của bản nhỏ về đêm. Một giấc ngủ sâu tại đây sẽ giúp bạn có tinh thần minh mẫn nhất cho hành trình đầy thử thách và vẻ đẹp sắp tới." 
      }
    ],
  },
  {
    day: "Thứ 6 - Lạc Vào Khu Rừng Cổ Tích",
    activities: [
      { time: "06:30 AM", description: "Ăn sáng và ngắm nhìn toàn cảnh thung lũng Tam Đường từ trên cao" },
      { 
        description: "Bữa sáng giàu năng lượng là điều bắt buộc. Tại đây, bạn có thể gửi lại những món đồ không cần thiết, chỉ mang theo niềm đam mê và một tâm hồn sẵn sàng khám phá." 
      },
      { time: "07:30 AM", description: "Xe máy trung chuyển đưa đoàn xuyên qua những cánh rừng mận tới điểm leo" },
      { 
        description: "Cảm giác lướt qua những con dốc, nghe tiếng gió luồn qua tóc sẽ là khởi đầu hoàn hảo cho chuyến đi. Hãy cứ thong thả, để bản thân được hòa nhịp với nhịp sống chậm rãi của Tây Bắc." 
      },
      { time: "09:00 AM", description: "Bắt đầu hành trình trekking qua khu rừng nguyên sinh huyền bí" },
      { 
        description: "Putaleng đón bạn bằng những gốc cây cổ thụ phủ đầy rêu phong. Đây là lúc đôi tay bạn chạm vào thiên nhiên, và đôi chân bắt đầu viết nên câu chuyện của riêng mình." 
      },
      { time: "12:00 PM", description: "Dừng chân nghỉ ngơi và ăn trưa bên dòng suối mát" },
      { 
        description: "Tiếng suối chảy như bản nhạc của rừng già sẽ xoa dịu mọi mệt mỏi. Một giấc ngủ ngắn 15 phút giữa đại ngàn sẽ giúp bạn 'sạc' lại đầy đủ năng lượng cho đoạn đường chiều." 
      },
      { time: "04:30 PM", description: "Tới lán nghỉ ở độ cao 2.400m" },
      { 
        description: "Đây là khoảng thời gian hoàng hôn buông xuống rừng già. Hãy cùng nhau tận hưởng những tách trà nóng, chụp những bức ảnh hoàng hôn ảo diệu ngay tại khu vực lán nghỉ trước khi bóng tối bao trùm." 
      },
      { time: "06:30 PM", description: "Dùng bữa tối ấm cúng với những món ăn đậm chất núi rừng" },
      { 
        description: "Dưới mái lán đơn sơ, chúng ta tạm biệt sóng điện thoại để thực sự lắng nghe nhau. Chăn đệm đã sẵn sàng để che chở bạn trong đêm lạnh vùng cao." 
      },
    ],
  },
  {
    day: "Thứ 7 - Chinh Phục Nữ Hoàng Đỗ Quyên",
    activities: [
      { time: "06:00 AM", description: "Thức dậy sớm, đón bình minh giữa biển sương" },
      { time: "07:00 AM", description: "Bắt đầu hành trình cuối cùng chạm đỉnh Putaleng" },
      { 
        description: "Đoạn đường này sẽ đưa bạn qua những rặng đỗ quyên cổ thụ. Hãy bước đi thật vững chắc, sự kiên trì của bạn sắp được đền đáp bằng một tầm nhìn vô tận." 
      },
      { time: "10:30 AM", description: "Chạm tay vào đỉnh Putaleng (3.049m)" },
      { 
        description: "Khoảnh khắc đứng trên đỉnh cao thứ 3 Việt Nam, mọi giới hạn đều bị phá vỡ. Hãy hít thật sâu và giữ lại cảm giác tự hào này, bạn thực sự là một chiến binh xinh đẹp và mạnh mẽ." 
      },
      { time: "01:00 PM", description: "Quay trở về lán nghỉ và thu dọn hành lý" },
      { time: "03:00 PM", description: "Di chuyển sang lán nghỉ hướng Tả Lèng" },
      { 
        description: "Cung đường này sẽ cho bạn thấy một diện mạo khác của Putaleng với những thảm rêu dày đặc và rừng trúc xanh mướt, đẹp như một bộ phim điện ảnh." 
      },
      { time: "06:00 PM", description: "Nghỉ ngơi và dùng bữa tối tại lán hướng Tả Lèng" },
      { 
        description: "Đêm cuối cùng trên núi, hãy để cơ thể được nghỉ ngơi tối đa sau một ngày dài chinh phục vinh quang." 
      }
    ],
  },
  {
    day: "Chủ Nhật - Suối Nguồn & Sự Phục Hồi",
    activities: [
      { time: "06:30 AM", description: "Ăn sáng và bắt đầu hành trình xuống núi qua hướng Tả Lèng" },
      { 
        description: "Hướng xuống này nổi tiếng với những dòng suối trong vắt và khu rừng già đẹp nhất vùng. Hãy lưu ý siết chặt dây giày để bảo vệ đầu gối và bước đi thật nhẹ nhàng." 
      },
      { time: "11:30 AM", description: "Dừng chân dùng bữa trưa bên thác nước cuối rừng" },
      { time: "01:30 PM", description: "Lên xe di chuyển về thị xã Sapa" },
      { time: "03:30 PM", description: "Tận hưởng combo tắm lá thuốc Dao Đỏ & Massage chân tại Sapa" },
      { 
        description: "Đây là món quà tuyệt vời nhất dành cho đôi chân của bạn. Hương thơm của các loại thảo mộc sẽ giúp bạn loại bỏ mọi đau nhức, làm mới lại làn da và tinh thần." 
      },
      { time: "06:00 PM", description: "Bữa tối liên hoan tổng kết hành trình tại trung tâm Sapa" },
      { 
        description: "Thưởng thức lẩu cá hồi hoặc đồ nướng Sapa trong không khí se lạnh, chia sẻ những kỷ niệm đẹp nhất của hành trình vừa qua." 
      },
      { time: "07:30 PM", description: "Lên xe khởi hành về lại Thủ đô" },
      { time: "01:00 AM", description: "Về tới Hà Nội. Chào tạm biệt và hẹn gặp lại bạn trong những hành trình tiếp theo!" }
    ],
  }
];

const PuTaLengSchedule = () => {
  const exportPDF = () => {
    const input = document.getElementById("schedule");
    html2canvas(input, { scale: 1.5 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/jpeg", 0.7); // 0.7 = chất lượng nén
      const imgWidth = 210;
      const pageHeight = (canvas.height * imgWidth) / canvas.width;

      const pdf = new jsPDF("p", "mm", [imgWidth, pageHeight]);
      pdf.addImage(imgData, "JPEG", 0, 0, imgWidth, pageHeight, null, "FAST");
      pdf.save("lich-trinh-ta-chi-nhu.pdf");
    });
  };


  return (
    <div>
    <div id="schedule" className="schedule-container" style={{ fontFamily: 'Arial, sans-serif', maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
      <div  className="day-schedule" style={{ marginBottom: '30px', borderLeft: '3px solid #6b8e23', paddingLeft: '15px' }}>
        <p className='block text-xl font-sans italic px-5 py-2'>👑 Pu Ta Leng – Nữ Hoàng Của Các Đỉnh Núi và Rừng Đỗ Quyên</p>
        <p className='block text-lg font-sans italic px-5 py-2'>
          Pu Ta Leng – ngọn núi cao 3.049 mét, được mệnh danh là “Nữ Hoàng của Tây Bắc” và là đỉnh cao thứ hai của Việt Nam.
           Đây là cung đường trekking thử thách bậc nhất về cả sức bền lẫn ý chí, dành cho những ai khao khát
            trải nghiệm sự hùng vĩ, nguyên sơ của núi rừng.
        </p>
        <p  className='block text-lg font-italic font-sans italic px-5 py-2'>
          Ảnh: Khung cảnh thiên nhiên của Putaleng
        </p>
        <img src={Putaleng} alt="" className="w-96 bg-white shadow-md border-4 border-white p-5 rounded-lg w-11/12" />
      </div>
        <h2 className ='text-5xl' style={{ color: '#387338', borderBottom: '2px solid #a8c6a8', paddingBottom: '10px' }}>
          Chi tiết
        </h2>
      {Schedule.map((dayData, index) => (
        <div key={index} className="day-schedule" style={{ marginBottom: '30px', borderLeft: '3px solid #6b8e23', paddingLeft: '15px' }}>
          <h3 style={{ color: '#6b8e23', backgroundColor: '#f0fff0', padding: '5px 10px', borderRadius: '4px' }}>
            {dayData.day}
          </h3>
          <ul style={{ listStyle: 'none', paddingLeft: '0' }}>
            {dayData.activities.map((activity, idx) => (
              <li key={idx} className="activity-item text-lg font-sans " style={{ marginBottom: '15px', display: 'flex' }}>
                <strong style={{ minWidth: '85px', color: '#333' }}>
                  {activity.time}
                </strong>
                <span style={{ flexGrow: 1, paddingLeft: '10px' }}>
                  {activity.description}
                </span>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
    <button 
        onClick={exportPDF}
        className=" m-5 px-5 py-2 bg-green-600 text-white px-4 py-2 rounded-md mb-4"
      >
        Xuất PDF
    </button>
  </div>
  );
};

export default PuTaLengSchedule;